export const supervisorCriticalDecisionActions = [
  "OPERATOR_REASSIGNED",
  "LINE_CHANGED",
  "TECHNICAL_SUPPORT_CALLED",
  "PUT_ON_HOLD",
  "RESUMED",
  "CANCELLED",
  "REOPENED",
  "FORCED_COMPLETION",
  "COMPLAINT_REVIEWED",
] as const;

export const supervisorRoutineDecisionActions = [
  "CONTINUE_IN_SHIFT",
  "SHIFT_TRANSFERRED",
  "RESCHEDULED",
  "START_TIME_CHANGED",
  "OVERRUN_CONTINUE_APPROVED",
  "REMINDER_SENT",
  "DELAY_REASON_RECORDED",
] as const;

export type SupervisorCriticalDecisionAction = (typeof supervisorCriticalDecisionActions)[number];

const supervisorCriticalDecisionActionSet = new Set<string>(supervisorCriticalDecisionActions);

export function isSupervisorCriticalDecisionAction(action: string): action is SupervisorCriticalDecisionAction {
  return supervisorCriticalDecisionActionSet.has(action);
}
